import React from 'react';
import { Navigate } from 'react-router-dom';

// This intentionally duplicates the ISO-date + timezone check from
// src/utils/blogDates.js instead of requiring it. blogDates.js is required
// (via require(), not import) from ~100 independently code-split page
// chunks; this guard is the only consumer that also needs it in the
// synchronously-loaded main bundle (it wraps route children directly in
// App.js, not behind lazyWithRetry). That sync+async split on the same
// CommonJS module made webpack's production build crash on load with
// `TypeError: Cannot assign to read only property 'exports'` before React
// ever mounted, taking down every page. Keeping this component
// self-contained avoids the shared-module boundary entirely.
const ISO_DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;
const BLOG_PUBLICATION_TIME_ZONE = 'America/Los_Angeles';

function todayIsoDate(timeZone = BLOG_PUBLICATION_TIME_ZONE) {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(new Date());
  const values = Object.fromEntries(
    parts.filter(({ type }) => type !== 'literal').map(({ type, value }) => [type, value])
  );
  return `${values.year}-${values.month}-${values.day}`;
}

function isPublished(dateStr) {
  return typeof dateStr === 'string' && ISO_DATE_PATTERN.test(dateStr) && dateStr <= todayIsoDate();
}

/** Prevent scheduled blog pages from rendering metadata or visible content early. */
const BlogPublicationGuard = ({ publishedAt, redirectTo, children }) => {
  return isPublished(publishedAt) ? children : <Navigate to={redirectTo} replace />;
};

export default BlogPublicationGuard;
